'use client';

import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { AppBar, ErrorNotice } from '~/components';
import { useEnvironmentInfo, useGoBack } from '~/hooks';
import { Dialog } from '@bgzt/ui';
import { closeWebviewOnApp } from '~/services/app-interface';

type Props = {
  error: CustomError & { digest?: string };
  reset: () => void;
};

export default function Error({ error, reset }: Props) {
  const { isWebview } = useEnvironmentInfo();
  const router = useRouter();
  const { goBack } = useGoBack();

  const is404 = error?.response?.status === 404;
  /** 삭제된 상품인 경우 */
  const [isDeleted, setIsDeleted] = useState(false);

  useEffect(() => {
    if (!error) return;

    error?.response?.json()?.then((data) => {
      setIsDeleted(data?.errorCode === 'ERR_DELETED_PRODUCT');
    });
  }, [error]);

  return (
    <>
      <AppBar actions={['home', 'search']} />

      {isDeleted ? (
        <Dialog
          title="삭제된 상품입니다."
          onClose={() => {
            isWebview ? goBack() : router.replace('/');
          }}
          isOpen
        />
      ) : (
        <ErrorNotice
          {...(is404 && { resetButtonText: '홈으로 이동' })}
          onResetClick={() => {
            if (is404) {
              isWebview ? closeWebviewOnApp().go() : router.replace('/');
            }

            reset();
          }}
        />
      )}
    </>
  );
}
